export default "__VITE_ASSET__CzmW5MTb__"